import { render } from "./CompaniesSettings.vue?vue&type=template&id=25c9de1a&ts=true"
import script from "./CompaniesSettings.vue?vue&type=script&lang=ts"
export * from "./CompaniesSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__